import {
  Component,
  computed,
  ElementRef,
  inject,
  Signal,
  signal,
  viewChild,
  WritableSignal,
} from '@angular/core';
import { MediaBlockService } from '../../services/media-block-service';
import { GpsUploader } from '../gps-uploader/gps-uploader';
import {
  ELEVATION_SCALE_WIDTH,
  SyncroEditorSlopeVisualizer,
} from '../syncro-editor-slope-visualizer/syncro-editor-slope-visualizer';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { ColorService } from '../../services/color.service';

import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-fullscreen-gps-modal',
  imports: [TranslateModule, GpsUploader, SyncroEditorSlopeVisualizer, IconComponent],
  templateUrl: './fullscreen-gps-modal.html',
  styleUrl: './fullscreen-gps-modal.scss',
})
export class FullscreenGpsModal {
  protected mediaBlockService: MediaBlockService = inject(MediaBlockService);
  protected colorService: ColorService = inject(ColorService);
  protected readonly elevationScaleWidth: number = ELEVATION_SCALE_WIDTH;
  protected barPosition: WritableSignal<number | null> = signal<number | null>(null);

  private slopeVisualizer: Signal<SyncroEditorSlopeVisualizer | undefined> = viewChild(
    SyncroEditorSlopeVisualizer,
  );
  private hoverableSectionRef: Signal<ElementRef<HTMLElement> | undefined> = viewChild(
    'hoverableSection',
    { read: ElementRef },
  );
  protected trackHeight: Signal<number | null> = computed(
    () => this.slopeVisualizer()?.trackHeight() ?? null,
  );

  protected moveBar(event: MouseEvent): void {
    const section: HTMLElement | undefined = this.hoverableSectionRef()?.nativeElement;
    const trackHeight: number | null = this.trackHeight();
    if (!section || trackHeight === null) return;

    const rect: DOMRect = section.getBoundingClientRect();
    const x: number = event.clientX - rect.left;
    const y: number = event.clientY - rect.top;
    const onTrack: boolean = x >= 0 && x <= rect.width && y >= 0 && y <= trackHeight;

    this.barPosition.set(onTrack ? x : null);
  }
}
